// extracted by mini-css-extract-plugin
module.exports = {"promoBox":"PromoBox_promoBox__X0lmd","layout":"PromoBox_layout__z_920","content":"PromoBox_content__qnVNS","image":"PromoBox_image__bBYey"};